import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import AbundanceParser from '../../../../../../abundanceEngine/AbundanceParser'
import AbundanceEngineContextProvider
  from '../../../../../../abundanceEngine/components/AbundanceParameterContextProvider'
import BackgroundProvider from '../../../../../../providers/BackgroundProvider/provider'
import ErrorBoundary from '../../../../../molecules/ErrorBoundary'

const useStyles = makeStyles(() => ({
  previewContainer: {
    '& .jsx-parser': {
      width: '100%',
      height: '100%',
      overflow: 'auto'
    }
  }
}))

// Contained Background Provider - wraps the real BackgroundProvider but contains its effects
function ContainedBackgroundProvider ({ children }) {
  return (
    <div style={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden' }}>
      <BackgroundProvider>
        {children}
      </BackgroundProvider>
    </div>
  )
}

ContainedBackgroundProvider.propTypes = {
  children: PropTypes.node.isRequired
}

function ContentPreviewView ({
  jsxContent
}) {
  const classes = useStyles()

  // If no content, show placeholder
  if (!jsxContent || jsxContent.trim() === '') {
    return (
      <div className='relative w-full h-full flex items-center justify-center'>
        <div className='text-center text-gray-500'>
          <h3 className='text-lg font-medium'>Preview</h3>
          <p className='text-sm'>No content to preview</p>
        </div>
      </div>
    )
  }

  return (
    <div className='relative w-full h-full overflow-hidden'>
      <div
        className={clsx('w-full h-full', classes.previewContainer)}
        style={{
          isolation: 'isolate',
          contain: 'layout style paint',
          position: 'relative',
          zIndex: 0
        }}
      >
        <ErrorBoundary key={`${jsxContent?.length}-${jsxContent?.slice(0, 50)}`} name='Abundance Engine Preview'>
          <ContainedBackgroundProvider>
            <AbundanceEngineContextProvider>
              <AbundanceParser jsx={jsxContent} />
            </AbundanceEngineContextProvider>
          </ContainedBackgroundProvider>
        </ErrorBoundary>
      </div>
    </div>
  )
}

ContentPreviewView.propTypes = {
  jsxContent: PropTypes.string
}

export default ContentPreviewView
